import { HStack, useToast } from '@chakra-ui/react';
import CustomFilterBtn from '@Modules/core/components/form/CustomFilterBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CardField from '@Modules/fraudManagement/components/CardField';
import CustomCardTable from '@Modules/fraudManagement/components/CustomCardTable';
import GenericFormUI from '@Shared/components/form/GenericFormUI';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getRepresentmentDataTableColumns, TRepresentmentDataTableData } from './RepresentmentDataTableMeta';


const initRepresentmentData: TRepresentmentDataTableData[] = [
  {
    primaryKey: 1,
    representment: "Sales Draft :",
    count: "0",
    total: ""
  },
  {
    primaryKey: 2,
    representment: "Credit voucher (Debit) :",
    count: "",
    total: ""
  },
  {
    primaryKey: 3,
    representment: "Cash disbursement :",
    count: "",
    total: ""
  },
  {
    primaryKey: 4,
    representment: "Total transaction :",
    count: "",
    total: ""
  },
];

const initRepresentmentReversalData: TRepresentmentDataTableData[] = [
  {
    primaryKey: 1,
    representment: "Sales Draft :",
    count: "0",
    total: ""
  },
  {
    primaryKey: 2,
    representment: "Credit voucher (Credit) :",
    count: "",
    total: ""
  },
  {
    primaryKey: 3,
    representment: "Cash disbursement :",
    count: "",
    total: ""
  },
  {
    primaryKey: 4,
    representment: "Total transaction :",
    count: "",
    total: ""
  },
]

const RepresentmentDataTableHandler = () => {
    
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ["RepresentmentDataTable"];
  const {
    data: representmentData,
    isLoading: representmentIsLoading,
  } = useQuery<TRepresentmentDataTableData[]>({
    queryKey: queryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve([
              {
                primaryKey: 1,
                representment: "Sales Draft :",
                count: "0",
                total: ""
              },
              {
                primaryKey: 2,
                representment: "Credit voucher (Debit) :",
                count: "",
                total: ""
              },
              {
                primaryKey: 3,
                representment: "Cash disbursement :",
                count: "",
                total: ""
              },
              {
                primaryKey: 4,
                representment: "Total transaction :",
                count: "",
                total: ""
              },
            ]), 500);
        });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const representmentReversalQueryKey = ["RepresentmentReversalDataTable"];
  const {
    data: representmentReversalData,
    isLoading: representmentReversalIsLoading,
  } = useQuery<TRepresentmentDataTableData[]>({
    queryKey: representmentReversalQueryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve([
              {
                primaryKey: 1,
                representment: "Sales Draft :",
                count: "324",
                total: ""
              },
              {
                primaryKey: 2,
                representment: "Credit voucher (Credit) :",
                count: "",
                total: ""
              },
              {
                primaryKey: 3,
                representment: "Cash disbursement :",
                count: "",
                total: ""
              },
              {
                primaryKey: 4,
                representment: "Total transaction :",
                count: "",
                total: ""
              },
            ]), 500);
        });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  
  const { isLoading: isSubmitting } = useMutation( async() =>{}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const representmentColumns = getRepresentmentDataTableColumns({
    isLoading: representmentIsLoading,
    title: "Representment",
  });

  const representmentReversalColumns = getRepresentmentDataTableColumns({
    isLoading: representmentReversalIsLoading,
    title: "Representment reversal",
  });
  
  const isLoading = representmentIsLoading && representmentReversalIsLoading;
  return (
    <>
      

      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        <CustomCardTable title='' data={representmentData || initRepresentmentData} columns={representmentColumns} />

        <CustomCardTable title='' data={representmentReversalData || initRepresentmentReversalData} columns={representmentReversalColumns} />

      </CC.SimpleGrid>

    </>
  );
};

export default RepresentmentDataTableHandler;
